<template>
  <div class="middle_inner" v-if="this.$route.path === '/ru/franchise'">
    <div class="franchide-page">
      <div class="middle_content entry"></div>
    </div>
    <Notice v-if="$store.getters.notice">
      {{ $store.getters.notice }}
    </Notice>
    <Notice v-for="(notice, i) in $store.getters.notices" :key="`notice-${i}`">
      {{ notice }}
    </Notice>
    <slot />
  </div>
  <div class="middle_inner" v-else>
    <div class="content_wrap fullwidth">
      <div class="middle_content entry"></div>
    </div>
    <Notice v-if="$store.getters.notice">
      {{ $store.getters.notice }}
    </Notice>
    <Notice v-for="(notice, i) in $store.getters.notices" :key="`notice-${i}`">
      {{ notice }}
    </Notice>
    <slot />
  </div>
</template>

<script>
import Notice from '@/components/Notice'

export default {
  name: 'ContentWrapperHome',
  components: { Notice },
}
</script>

<style>
.middle_content {
  min-height: 400px;
}
</style>
